import { type OpportunitiesSearchOptions } from "./types";

export const initialOpportunityOptions: OpportunitiesSearchOptions = {
  pageIndex: 0,
  pageSize: 10,
  sortKey: "opportunityId",
  sortOrder: "desc",
};
